import React, { PureComponent }    from 'react';
import { Translate }               from 'react-localize-redux';
import { connect }                 from 'react-redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import { compose }                 from 'redux';
import styled                      from 'styled-components';
import Indicator                   from '../../../components/indicator';
import ImgFrame                    from '../images/participate_frame.png';
import Section                     from '../section';
import titleImg                    from '../images/title/Participate.png';

const Container = styled.div`
  padding: 2em 1em;
`;

const Record = styled.div`
  width: 21em;
  height: 5em;
  margin: auto;
  background-repeat:no-repeat;
  background-size:contain;
  background-position: center center;
  background-image: url(${ImgFrame});

  display: flex;
`

const THead = styled.div`
  margin-top: 1.9em;
  margin-left: 2.6em;
`
const TData = styled.div`
    color: ${props => props.theme.primary};
    margin-top: 1.5em;
    margin-left: 1em;
`

const Heads = styled.div`
  font-size    : 0.8em;
`;

const Warning = styled.div`
  font-size    : 0.7em;
  color        : white;
  margin-top   : 0.3em;
`;

/**
 * Participate section
 */
class Participate extends PureComponent {
  render() {
    const { game, gameId } = this.props;

    return (
      <Container>
      <Section imgSrc={titleImg} >
        {!game && <Indicator spin />}
        {game && (
          <>
            <Record>
                  <THead><Translate id="cmpLandingPage.participate.no1.no" /></THead>
                  <TData>
                     <Heads><Translate id="cmpLandingPage.participate.no1.label" /></Heads>
                     <Warning><Translate id="cmpLandingPage.participate.no1.explanation" /></Warning>
                  </TData>
            </Record>
            <Record>
                  <THead><Translate id="cmpLandingPage.participate.no2.no" /></THead>
                  <TData>
                     <Heads><Translate id="cmpLandingPage.participate.no2.label" /></Heads>
                     <Warning><Translate id="cmpLandingPage.participate.no2.explanation" /></Warning>
                  </TData>
            </Record>
            <Record>
                  <THead><Translate id="cmpLandingPage.participate.no3.no" /></THead>
                  <TData>
                     <Heads><Translate id="cmpLandingPage.participate.no3.label" /></Heads>
                     <Warning><Translate id="cmpLandingPage.participate.no3.explanation" /></Warning>
                  </TData>
            </Record>
          </>
        )}
      </Section>
      </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global, firebase }) => {
  const gameId = global.gameId;
  return {
    gameId,
    game: getVal(firebase.data, `games/${gameId}`),
    databaseLoaded: global.loadedResources.database
  };
};

export default compose(
  connect(mapStateToProps, null),
  firebaseConnect(({ gameId, databaseLoaded }) => {
    // Check for database loaded
    if (!databaseLoaded) {
      return;
    }
    return [`games/${gameId}`];
  })
)(Participate);
